import ApiService from './ApiService';

const API_URLS = window.AppConfig.API_URLS;

export default class TransactionHistoryProfile {
	static async getAllTransactionByUser(queryParams) {
		return ApiService.GetData(`${API_URLS.TRANSACTION_HISTORY_PROFILE}${queryParams}`, 'transaction');
	}

	static async getTransactionByUserId(id, queryParams) {
		return ApiService.GetData(`${API_URLS.TRANSACTION_HISTORY_ADMIN}/${id}${queryParams}`, 'transaction');
	}

	static async sendReport(body) {
		return ApiService.PostData(`${API_URLS.TRANSACTION_HISTORY_SEND_REPORT}`, body, 'transaction');
	}
}
